export enum MachinePreferencesUrlParam {
  MACHINE_ID = 'machineId',
  CALL_CENTER_CODE = 'callcenter',
  STATION_NUMBER = 'station',
}
